import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { toastNotification } from '../components/toast/Toast';
import queryClient from '../query-client';

type RefreshFYIDocumentsRequest = {
    workpaperId?: string;
    entityId?: string;
    ids?: string[];
};

type RefreshFYIDocumentsResponse = { results: { created: number; updated: number } };

async function refreshFYIDocuments(req: RefreshFYIDocumentsRequest): Promise<RefreshFYIDocumentsResponse> {
    const { data } = await api.post(`/fyi-docs/refresh/documents`, req);
    return data;
}

export function useRefreshFYIDocuments(
    silent = false
): UseMutationResult<RefreshFYIDocumentsResponse, AxiosError, RefreshFYIDocumentsRequest, unknown> {
    return useMutation(refreshFYIDocuments, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
            queryClient.invalidateQueries(['worksheets']);
        },
        onSuccess: ({ results }) => {
            if (!silent) {
                toastNotification('success', `Re-synced documents from FYI.`, `${results.created} created. ${results.updated} updated.`);
            }
        },
        onError: () => {
            toastNotification('error', 'Unable to re-sync documents from FYI.');
        },
    });
}
